<div class="newrule__header">
  <h2>Keep your teammates in the loop</h2>
  <span class="subtitle">
    Save time by automating notifications. You can create notifications for your teammates to remind them about new
    tasks or alterations.
  </span>
  <span class="rules__close-btn" (click)="dismissModal()">
    <img src="/assets/iconography/cancel.svg" width="24px" height="24px" />
  </span>
</div>

<div class="newrule__body" fxLayout>
  <div fxFlex>
    <h3>Notify for an event</h3>
    <div
      fxLayout
      class="newrule__option-container"
      fxLayoutGap="12px"
      (click)="createNotificationRule('New Reservation', 'team:accepted')">
      <img src="/assets/iconography/nav-notifications.svg" />
      <span class="newrule__option strong" fxFlex>New reservation</span>
    </div>
    <div
      fxLayout
      class="newrule__option-container"
      fxLayoutGap="12px"
      (click)="createNotificationRule('New Alteration', 'team:alteration')">
      <img src="/assets/iconography/nav-notifications.svg" />
      <span class="newrule__option strong" fxFlex>New alteration</span>
    </div>
    <div
      fxLayout
      class="newrule__option-container"
      fxLayoutGap="12px"
      (click)="createNotificationRule('New Cancellation', 'team:cancelled')">
      <img src="/assets/iconography/nav-notifications.svg" />
      <span class="newrule__option strong" fxFlex>New cancellation</span>
    </div>
    <div
      fxLayout
      class="newrule__option-container"
      fxLayoutGap="12px"
      (click)="createNotificationRule('New Inquiry', 'team:inquiry')">
      <img src="/assets/iconography/nav-notifications.svg" />
      <span class="newrule__option strong" fxFlex>New inquiry</span>
    </div>
  </div>

  <div fxFlex>
    <h3>Schedule a reminder</h3>
    <div
      fxLayout
      class="newrule__option-container"
      fxLayoutGap="12px"
      (click)="createNotificationRule('Before check-in', 'team:checkin', true)">
      <img src="/assets/iconography/gx-create/check-in.svg" />
      <span class="newrule__option strong" fxFlex>Before check-in</span>
    </div>
    <div
      fxLayout
      class="newrule__option-container"
      fxLayoutGap="12px"
      (click)="createNotificationRule('After check-in', 'team:checkin')">
      <img src="/assets/iconography/gx-create/check-in.svg" />
      <span class="newrule__option strong" fxFlex>After check-in</span>
    </div>
    <div
      fxLayout
      class="newrule__option-container"
      fxLayoutGap="12px"
      (click)="createNotificationRule('Before check-out', 'team:checkout', true)">
      <img src="/assets/iconography/gx-create/check-out.svg" />
      <span class="newrule__option strong" fxFlex>Before check-out</span>
    </div>
    <div
      fxLayout
      class="newrule__option-container"
      fxLayoutGap="12px"
      (click)="createNotificationRule('After check-out', 'team:checkout')">
      <img src="/assets/iconography/gx-create/check-out.svg" />
      <span class="newrule__option strong" fxFlex>After check-out</span>
    </div>
  </div>

  <div fxFlex>
    <h3>Notify for a task</h3>
    <div
      fxLayout
      class="newrule__option-container"
      fxLayoutGap="12px"
      (click)="createNotificationRule('Task assigned', 'team:task:created')">
      <img src="/assets/iconography/nav-notifications.svg" />
      <span class="newrule__option strong" fxFlex>Task assigned</span>
    </div>
    <div
      fxLayout
      class="newrule__option-container"
      fxLayoutGap="12px"
      (click)="createNotificationRule('Task updated', 'team:task:updated')">
      <img src="/assets/iconography/nav-notifications.svg" />
      <span class="newrule__option strong" fxFlex>Task updated</span>
    </div>
    <div
      fxLayout
      class="newrule__option-container"
      fxLayoutGap="12px"
      (click)="createNotificationRule('Task cancelled', 'team:task:deleted')">
      <img src="/assets/iconography/nav-notifications.svg" />
      <span class="newrule__option strong" fxFlex>Task cancelled</span>
    </div>
  </div>
</div>
